export enum Keys {
  ESCAPE = 27,
}
